<template>
    <div class="product-page my-container page">
        <div class="top">
            <div class="image-wrapper">
                <img :src="product.image" :alt="product.slug">
            </div>
            <div class="info">
                <h1 class="header">{{ product.title[locale] }}</h1>
                <div class="star-row">
                    <div class="star-container">
                        <Icon name="twemoji:star" size="14" v-for="i in Math.round(product.rating)" />
                        <Icon name="clarity:star-solid" size="14" v-for="i in (5 - Math.round(product.rating))"
                            v-if="Math.round(product.rating) < 5" fill="gray" />
                    </div>
                    <span>{{ product.rating }}</span>
                    <Icon name="oui:dot" size="14" />
                    <span>{{ ratingCount }} {{ t('ratings') }}</span>
                </div>
                <p class="short-description">
                    {{ product.short_description[locale] }}
                </p>
                <div class="typo-body-m">
                    {{ t('specs') }}
                </div>
                <div class="spec-row" v-for="spec in partSpecs">
                    <div class="left">
                        <div class="typo-body-m">{{ spec.title[locale] }}</div>
                        <div class="dashes"></div>
                    </div>
                    <div class="typo-body-m">
                        {{ spec.description[locale] }}
                    </div>
                </div>
                <div class="typo-body-m all-specs-link" @click="viewAllSpecs">
                    {{ t('allSpecs') }}
                </div>
            </div>
        </div>
        <UTabs :items="tabItem" class="w-full pc" :ui="config" v-model="selectedTab">
            <template #default="{ item, index, selected }">
                <div class="flex align-center justify-center gap-2">
                    {{ item.label }}
                    <template v-if="index === 3">
                        <Icon name="twemoji:star" size="14" />
                        {{ product.rating }}
                    </template>
                </div>
            </template>
            <template #description>
                <div class="typo-body-m" style="opacity:0.7">{{ product.description[locale] }}</div>
            </template>
            <template #specs>
                <div style="max-width: 800px;" ref="tabs">
                    <div class="spec-row" v-for="spec in product.characteristics">
                        <div class="left">
                            <div class="typo-body-m">{{ spec.title[locale] }}</div>
                            <div class="dashes"></div>
                        </div>
                        <div class="typo-body-m">
                            {{ spec.description[locale] }}
                        </div>
                    </div>
                </div>
            </template>
            <template #composition>
                <div class="composition">
                    <div class="typo-body-m" v-for="entry in product.composition"><b>{{ entry.title[locale] }}</b> - {{
                        entry.description[locale] }}</div>
                </div>
            </template>
            <template #reviews>
                <div class="review-tab">
                    <div class="review-info">
                        <div class="title">{{ t('productReviews') }}</div>
                        <div class="star-row">
                            <div class="star-container">
                                <Icon name="twemoji:star" size="14" v-for="i in Math.round(product.rating)" />
                                <Icon name="clarity:star-solid" size="14" v-for="i in (5 - Math.round(product.rating))"
                                    v-if="Math.round(product.rating) < 5" fill="gray" />
                            </div>
                            <span>{{ product.rating }}</span>
                            <Icon name="oui:dot" size="14" />
                            <span>{{ ratingCount }} {{ t('ratings') }}</span>
                        </div>
                        <div>{{ t('byRating') }}</div>
                        <div class="review-row" v-for="entry in product.rating_count">
                            <span class="text typo-body-m">{{ entry.rating }}</span>
                            <Icon name="twemoji:star" size="14" />
                            <div class="progress">
                                <div class="inner" :style="{ width: entry.count / ratingCount * 100 + '%' }">

                                </div>
                            </div>
                            <div class="text typo-body-m">{{ entry.count }} {{ t('reviews2') }}</div>
                        </div>
                    </div>
                    <div class="review-list">

                        <div v-for="rev in reviews" :key="rev.id">
                            <div class="top-line">
                                {{ rev.client_name }}
                                <span class="entry-info">
                                    {{ new Date(rev.published_at).toLocaleDateString('ru') }}
                                    <Icon name="twemoji:star" size="14" v-for="i in rev.rating" />
                                    <Icon name="clarity:star-solid" size="14" v-for="i in (5 - rev.rating)"
                                        v-if="rev.rating < 5" fill="gray" />
                                </span>
                            </div>
                            <div class="bottom">{{ rev.comment }}</div>

                        </div>
                    </div>
                    <div class="btn-container">
                        <button class="my-btn" @click="modal = true">
                            {{ t('writeReview') }}
                        </button>
                    </div>
                </div>
            </template>
        </UTabs>
        <UAccordion v-model="selectedTab" :items="tabItem" class="accordeon mobile">
            <template #description>
                <div class="typo-body-m" style="opacity:0.7">{{ product.description[locale] }}</div>
            </template>
            <template #specs>
                <div style="max-width: 800px;" ref="tabs">
                    <div class="spec-row" v-for="spec in product.characteristics">
                        <div class="left">
                            <div class="typo-body-m">{{ spec.title[locale] }}</div>
                            <div class="dashes"></div>
                        </div>
                        <div class="typo-body-m">
                            {{ spec.description[locale] }}
                        </div>
                    </div>
                </div>
            </template>
            <template #composition>
                <div class="composition">
                    <div class="typo-body-m" v-for="entry in product.composition"><b>{{ entry.title[locale] }}</b> - {{
                        entry.description[locale] }}</div>
                </div>
            </template>

            <template #reviews>
                <div class="review-accordeon">
                    <div class="review-info">
                        <div class="title">{{ t('productReviews') }}</div>
                        <div class="star-row">
                            <div class="star-container">
                                <Icon name="twemoji:star" size="14" v-for="i in Math.round(product.rating)" />
                                <Icon name="clarity:star-solid" size="14" v-for="i in (5 - Math.round(product.rating))"
                                    v-if="Math.round(product.rating) < 5" fill="gray" />
                            </div>
                            <span>{{ product.rating }}</span>
                            <Icon name="oui:dot" size="14" />
                            <span>{{ ratingCount }} {{ t('ratings') }}</span>
                        </div>
                        <div>{{ t('byRating') }}</div>
                        <div class="review-row" v-for="entry in product.rating_count">
                            <span class="text typo-body-m">{{ entry.rating }}</span>
                            <Icon name="twemoji:star" size="14" />
                            <div class="progress">
                                <div class="inner" :style="{ width: entry.count / ratingCount * 100 + '%' }">

                                </div>
                            </div>
                            <div class="text typo-body-m">{{ entry.count }} {{ t('reviews2') }}</div>
                        </div>
                    </div>
                    <div class="btn-container">
                        <button class="my-btn flex justify-center mb-4">
                            {{ t('writeReview') }}
                        </button>
                    </div>
                    <div class="review-list">

                        <div v-for="rev in reviews" :key="rev.id">
                            <div class="top-line">
                                {{ rev.client_name }}
                                <span class="entry-info">
                                    <span>
                                        {{ new Date(rev.published_at).toLocaleDateString('ru') }}
                                    </span>
                                    <Icon name="twemoji:star" size="14" v-for="i in rev.rating" />
                                    <Icon name="clarity:star-solid" size="14" v-for="i in (5 - rev.rating)"
                                        v-if="rev.rating < 5" fill="gray" />
                                </span>
                            </div>
                            <div class="bottom">{{ rev.comment }}</div>

                        </div>
                    </div>

                </div>
            </template>

        </UAccordion>
        <h2 class="header">
            {{ product.subtitle[locale] }}
        </h2>
        <img v-if="product.banner[locale]" :src="product.banner[locale]" :alt="product.subtitle[locale]" class="banner">
        <h2 class="header" v-if="recs.length">
            {{ t('recommend') }}
        </h2>
        <div class="recommend">
            <ApplicationProductCard :base="`/catalog/${route.params.type}/${route.params.id}/group/${route.params.group}/product/`" v-for="prod in recs" :key="prod.id" :product="prod" />
        </div>
        <ReviewModal v-model="modal" :product-id="route.params.product" @review-sent="updateReviews" />
    </div>
</template>

<script setup>
const { locale, t } = useI18n()
const route = useRoute();
const rc = useRuntimeConfig();
const res = await Promise.all([
    $fetch(rc.public.api + '/api/product/' + route.params.product),
    $fetch(rc.public.api + '/api/review', {
        query: {
            'filters[product_id]': route.params.product
        }
    }),
    $fetch(rc.public.api + '/api/product', {
        query: {
            page: 1,
            limit: 5,
            [`filters[${route.params.type}_id]`]: route.params.id,
            'filters[group_id]': route.params.group
        }
    })
])
const product = ref(res[0].data)
const reviews = ref(res[1].data.list)
const recs = ref(res[2].data.list.filter(el => el.id != route.params.product).slice(0, 4))

const ratingCount = computed(() => {
    if (!product.value) return 0;
    const ratings = product.value.rating_count.map(({ count }) => count);
    return ratings.reduce((acc, el) => acc + el, 0)
})
const partSpecs = computed(() => product.value.characteristics.slice(0, 3))

const tabItem = computed(() => [{
    label: t('description'),
    slot: 'description'
}, {
    label: t('specs'),
    slot: 'specs'
}, {
    label: t('composition'),
    slot: 'composition'
},
{
    label: t('reviews'),
    slot: 'reviews'
}
])
const config = reactive(
    {
        wrapper: 'relative space-y-2',
        container: 'relative w-full product-container',
        base: 'focus:outline-none',
        list: {
            base: 'relative gap-2',
            background: 'bg-gray-100 dark:bg-gray-800',
            rounded: 'rounded-lg',
            shadow: '',
            padding: 'p-0',
            height: 'h-10',
            width: 'w-full',
            marker: {
                wrapper: 'absolute top-[4px] left-[4px] duration-200 ease-out focus:outline-none',
                base: 'w-full h-full',
                background: 'red-bg',
                rounded: 'rounded-md',
                shadow: 'shadow-sm',
            },
            tab: {
                base: 'relative inline-flex items-center justify-center flex-shrink-0 w-full ui-focus-visible:outline-0 ui-focus-visible:ring-2 ui-focus-visible:ring-primary-500 dark:ui-focus-visible:ring-primary-400 ui-not-focus-visible:outline-none focus:outline-none disabled:cursor-not-allowed disabled:opacity-75 transition-colors duration-200 ease-out',
                background: '',
                active: 'active',
                inactive: 'inactive',
                height: 'h-8',
                padding: 'p-6',
                size: 'text-sm',
                font: 'font-medium',
                rounded: 'rounded-md',
                shadow: '',
                icon: 'w-4 h-4 flex-shrink-0 me-2',
            },
        },
    }
)
const selectedTab = ref(0)
const tabs = ref()

function viewAllSpecs() {
    selectedTab.value = 1
    setTimeout(() => {
        tabs.value.scrollIntoView(false);
    }, 0)
}
const modal = ref(false)

</script>